import { render, staticRenderFns } from "./RecomendedPlan.vue?vue&type=template&id=72348b58"
import script from "./RecomendedPlan.vue?vue&type=script&lang=js"
export * from "./RecomendedPlan.vue?vue&type=script&lang=js"
import style0 from "./RecomendedPlan.vue?vue&type=style&index=0&id=72348b58&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports